export const welcomeView = {
    "start": "ເລີ່ມຕົ້ນ",
    "test_info": "ບົດສະຫຼຸບຂອງການທົດສອບ",
    "practice_info": "ບົດສະຫຼຸບການເຝິກຫັດ",
    "exam_info": "ບົດສະຫຼຸບການສອບເສັງ",
    "lesson_info": "ບົດສະຫຼຸບບົດຮຽນ",
    "logged_out": "ທ່ານໄດ້ອອກຈາກການທົດສອບກ່ອນໜ້ານີ້",
    "continue_wc": "ສືບຕໍ່",
};

